import { render, staticRenderFns } from "./ChatBlock.vue?vue&type=template&id=4fe06cc1&"
import script from "./ChatBlock.vue?vue&type=script&lang=js&"
export * from "./ChatBlock.vue?vue&type=script&lang=js&"
import style0 from "./ChatBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports